import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../right.scss";
import "../../PageRight.scss";
import { useTranslation, withTranslation } from "react-i18next";
import { IMAGE_DNS } from "../../../../../../utils/config/Config";
import Footer from "../../../../../common/footer/Footer";
import { useInView } from "react-intersection-observer";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  isDeleteLoadingState,
  isThroughMainState
} from "../../../../../../atoms/atom";
import NotContent from "../NotContent";
import Social from "../../Social/Social";
import WrapLoading from "../../../../../common/loading/WrapLoading";
import { IPostContent, useInfiniteScrollQuery } from "../api";
import IsMyArticle from "../../../../common/isMyarticle/IsMyArticle";
import ContentsTags from "../../../../common/ContentsTags";
import PostFeedLoading from "../../../../../common/loading/PostFeedLoading";
import ScrollLoading from "../ScrollLoading";
import { PhotoAlbum } from "react-photo-album";

function PostFeedContent() {
  const { t } = useTranslation();
  const { service_code, title } = useParams();

  const sectionTItle = title === undefined ? "all" : title;
  const isDeleteLoading = useRecoilValue(isDeleteLoadingState);
  const setIsThroughMain = useSetRecoilState(isThroughMainState);
  const postProps = {
    service_code,
    sectionTItle
  };

  const { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible } =
    useInfiniteScrollQuery(postProps);

  const [ref, isView] = useInView();

  useEffect(() => {
    if (isView && getNextPageIsPossible) {
      getNextPage();
    }
  }, [isView, getBoard]);

  useEffect(() => {
    if (title === undefined) {
      return;
    } else {
      window.scrollTo(0, 0);
    }
  }, [title]);

  const checkPostState = () => {
    setIsThroughMain(true);
  };

  const min = 128;
  const max = 640;
  const randomHeight = Math.floor(Math.random() * (max - min + 1)) + min;

  const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

  const photos = (imgs: any) => {
    const data = imgs.map((photo: string) => ({
      src: photo,
      width: 1080,
      height: 800,
      srcSet: breakpoints.map((breakpoint) => {
        const height = randomHeight;
        return {
          src: photo,
          width: breakpoint,
          height
        };
      })
    }));

    return data;
  };

  return isDeleteLoading ? (
    <WrapLoading />
  ) : (
    <article className="wrap-article">
      <div>
        {getBoardIsSuccess ? (
          getBoard?.pages[0].result === 1 ? (
            getBoard?.pages.map((pageData) =>
              pageData.boardpage.map((i: IPostContent) => (
                <div className="article img clearfix" key={i.idx}>
                  {/* 게시자 info */}
                  <div className="info">
                    <img
                      className="user-pic"
                      src={
                        i.admin_icon === ""
                          ? IMAGE_DNS +
                            "/Valofe_file/web/vfun/images/common/img-user-default-min.png"
                          : i.admin_icon
                      }
                      alt="user-id"
                    />
                    <IsMyArticle
                      user_id={i.user_id}
                      idx={i.idx}
                      nickname={i.nickname}
                    />
                    <div className="info-writing f-right">
                      <img
                        className="icon-clock"
                        src={
                          IMAGE_DNS +
                          "/Valofe_file/web/vfun/images/common/icon/icon-clock-min.png"
                        }
                        alt="게시글 등록 시간"
                      />
                      {i.created_at}
                    </div>
                  </div>

                  {/* 컨텐츠 제목, 내용 */}
                  <div className="cont clearfix">
                    <h3
                      className="title"
                      dangerouslySetInnerHTML={{ __html: i.title }}
                    />
                    <ContentsTags
                      data={i.content}
                      className="text"
                      admin={i.admin_flag}
                      type="feed"
                    />
                    {/* 이미지 */}
                    {i.images !== null ? (
                      <div className={`txt`}>
                        <PhotoAlbum photos={photos(i.images)} layout="rows" />
                      </div>
                    ) : null}
                  </div>
                  {/* 좋아요, 댓글 */}
                  <Social
                    likeCount={i.like_count}
                    idx={i.idx}
                    userLike={i.user_like_status}
                    commentCount={i.comment_count}
                    categoryTitle={sectionTItle}
                  />
                  <div className="top-comment">
                    <img
                      className="user-pic"
                      src="//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
                      alt="로그인 전- 아이콘"
                    />
                    <Link
                      to={`${sectionTItle}/${i.idx}`}
                      onClick={checkPostState}
                    >
                      <input
                        className="input-comment"
                        type="text"
                        placeholder={t("Please_leave_a_reply")}
                        readOnly={true}
                      />
                    </Link>
                  </div>
                </div>
              ))
            )
          ) : (
            <NotContent />
          )
        ) : (
          <PostFeedLoading />
        )}
        <ScrollLoading
          loadingConditions={
            getNextPageIsPossible === true && getBoard?.pages[0].result === 1
          }
          viewRef={ref}
        />
      </div>
    </article>
  );
}

export default withTranslation()(PostFeedContent);
